/**
 * This is the driver for order submission.  Each topic is its own component that allows them
 * to easily be changed and order swapped around.
 */
import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { CircularProgress, Grid, Typography } from '@mui/material';

import StepperSubscriptionOrder from './StepperSubscriptionOrder';

const styles = theme => ({
  root: {
    marginTop: -24,
    // margin: "0 auto",
    // padding: "0 72px"
  },
  headerContainer: {
    marginBottom: 32,
    //maxWidth: 600,
    minWidth: 466
  },
  headerItem: {
    maxWidth: 600,
  },
  instructionsContainer: {
    maxWidth: 600,
    minWidth: 466
  },
  becomeAPartner: {
    minWidth: 150,
    maxWidth: 250,
    padding: 16,
    borderRadius: "10px"
  },
  becomeTop: {
    marginTop: 16
  },
  faq: {
    maxWidth: 600,
    margin: "0 auto"
  }
});


class PartnerHome extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      landingQueryOne: false,
      landingAppCount: 0,
      landingApps: [],
      accountPath: null,
      soLandingId: null,
      pageTitle : null,
      commissionTitle: null
    };
  }

  componentDidMount() {
    // console.log('componentDidMount');
    
    const { isAuthenticated, isAuthenticatedReseller, logoutWithoutRedirect } = this.props.auth;
    if (isAuthenticated()) {
      if (isAuthenticatedReseller()) {
        //below ensures that reloading only happens once, else an infinite loop.
        var soReload = localStorage.getItem("soreload");
        if (soReload) {
          localStorage.removeItem("soreload");
        } else {
          
          localStorage.setItem("soreload", true);
          window.location.reload();  
      }
      } else {
      // Logout current user
        logoutWithoutRedirect();
        window.location.reload();  
      }
    }

    //extract the landing path out of the URL - used to look up apps.
    let currentPath = this.props.location.pathname;
    // console.log('currentPath is ' + currentPath);
    let accountPath = 'N';
    // Extract after partner route /order/ (was /partnerhome/)
    if (currentPath.length > 6) {
      accountPath = currentPath.substring(7);
    }
    const params = new URLSearchParams(this.props.location.search);

    let packageParm = null;
     //we need to support 3 use cases
    //1) https://local.appbind.com:3000/order/demo?package=testim
    //2) https://local.appbind.com:3000/order/demo/testim
    //3) https://local.appbind.com:3000/order/demo  <- uses default so package in this last case
    if (params.get("package") != null) {
      //use case 1
      packageParm = params.get("package");
      localStorage.setItem("accountPath", accountPath);
    } else {
      //package param was null.  Lets see if it part of the URL
      if (accountPath.indexOf('/') === -1) {
        //use case 3 - see what happens above
        packageParm = "vendorDefault";
        localStorage.setItem("accountPath", accountPath);
      } else {
        //use case 2
        let accountPathOrig = accountPath;
        accountPath = accountPathOrig.substring(0, accountPathOrig.indexOf('/'));
        packageParm = accountPathOrig.substring(accountPathOrig.indexOf('/') + 1, accountPathOrig.length);
        localStorage.setItem("accountPath", accountPath);
      }
    };

    let callTarget = 'appbind/landingpage/' + accountPath + '/' + packageParm + "?apps=true";

    const { callPartnerApi } = this.props.auth;
    callPartnerApi(callTarget, 'GET', null)
    .then(response => {
      return response.json();
    }).then(data => {
      // console.log('received data from landing page');
      if (data.landingpage && data.landingpage.totalCount > 0) {
        let soLandingId = data.landingpage.nodes[0].soLandingId;
        let pageTitle = data.landingpage.nodes[0].pageTitle;
        let commissionTitle = data.landingpage.nodes[0].commissionTitle;
        this.setState({landingQueryOne: true, landingAppCount: data.landingpage.totalCount, landingApps: data.landingpage.nodes, accountPath: accountPath, soLandingId: soLandingId, pageTitle: pageTitle, commissionTitle: commissionTitle});
        // console.log('enough data to show SO');
      } else {
        // console.log('not enough data to show SO');
        this.setState({landingQueryOne: true});
      }
    }).catch(err => {
      //this will stop the spinning wheel but since no data will redirect.
      // console.log('not enough data to show SO - err: ' + err);
      this.setState({landingQueryOne: true});
    });
  }
  
  render() {

    //const { isAuthenticated, isAuthenticatedReseller, needAssent } = this.props.auth;
    const { classes } = this.props;

 
    if (!this.state.landingQueryOne) { 

      return (
        <div className={classes.root}>
          <Grid container direction="column" justifyContent="center">
            <Grid item>
              <Grid container spacing={0} direction="row" justifyContent="center" className={classes.spinny}>
                <Grid item>
                  <CircularProgress color="primary" size={75} thickness={2}/>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      );

    } else if (this.state.landingAppCount === 0) {

      //landing page not found
      return ( <Redirect to='/home' /> );
    
    } else {

      let title = '';
      let commissionTitle = '';

      if (this.state.pageTitle) {
        title = this.state.pageTitle;
      }
      if (this.state.commissionTitle) {
        commissionTitle = this.state.commissionTitle;
      }

      if (title === '') {
        if (this.state.landingAppCount === 1 ) {
          title = 'Order subscription to ' + this.state.landingApps[0].appName + ' for your customer';
        } else if (this.state.landingAppCount === 2) {
          title = 'Order subscription to ' + this.state.landingApps[0].appName + ' / ' + this.state.landingApps[0].appName + ' for your customer';
        } else {
          title = "Order subscription for your customer";  //TODO needs more discussion
        }
      }

      /* JD 2020/10/12 - no default
      if (commissionTitle === '') {
        //TODO - what is base sentence
        commissionTitle = 'Earn increased margins when you manage sale to a customer.';        
      }
      */

      let displayLogo = false;
      let logoPath = '';
      for (let i = 0; i < this.state.landingApps.length; i++) {
        let app = this.state.landingApps[i];
        if (app.appLogo) {
          logoPath = app.appLogo;
          displayLogo = true;
          break
        }
      }

      return (
        <div className={classes.root}>
          {/* header section */}
          <Grid container direction="column" justifyContent="center" alignItems="center" spacing={1} className={classes.headerContainer}>
            {displayLogo &&
             <Grid item xs={12}>
              <img alt="App" height="48px" src={logoPath} />
            </Grid>
            }
            <Grid item xs={12} className={classes.headerItem}>
              <Typography variant="h4" align="center">
                {title}
              </Typography>
            </Grid>
            <Grid item xs={12} className={classes.headerItem}>
              <Typography variant="h6" align="center">
                  {commissionTitle}
              </Typography>
            </Grid>
          </Grid>

           {/* 3 step instruction section */}
          <Grid container direction="column" justifyContent="center" alignItems="center" spacing={2}>
            <Grid item xs={12} style={{marginBottom: 32}}>
              <Grid container justifyContent="flex-start" alignItems="flex-start" spacing={3} className={classes.instructionsContainer}>
                <Grid item xs={4}>
                  <Typography variant="h6" >
                   1. Place an order
                  </Typography>
                  <Typography variant="body1" >
                   Who are you buying the subscription for, and how are they paying for it?
                  </Typography>
                </Grid>

                <Grid item xs={4}>
                  <Typography variant="h6" >
                   2. Get credentials
                  </Typography>
                  <Typography variant="body1" >
                   Get a virtual email address and purchase card to purchase the subscription.
                  </Typography>
                </Grid>

                <Grid item xs={4}>
                  <Typography variant="h6" >
                   3. Sign up and setup
                  </Typography>
                  <Typography variant="body1" >
                   Sign up with the credentials.  They'll track, manage, and expense the subscription.
                  </Typography>
                </Grid>

              </Grid>
            </Grid>
            
            <Grid item xs={12}>
              <Grid container justifyContent="center" alignItems="center">
                <Grid item>
                  <StepperSubscriptionOrder auth={this.props.auth} 
                                            history={this.props.history}
                                            landingAppCount={this.state.landingAppCount} 
                                            landingApps={this.state.landingApps}
                                            landingPath={this.state.landingPath}
                                            soLandingId={this.state.soLandingId}
                                            commissionTitle={this.state.commissionTitle}/>

                </Grid>
              </Grid>
            </Grid>

            {/* FAQ section */}
            <Grid item xs={12} sm={7}  className={classes.faq}>
              <Grid container spacing={1} justifyContent="center">
                <Grid item xs={12}>
                  <Typography variant="h6" >
                      FAQ
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle2">
                      How does this work?
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" >
                      For each subscription, you will be issued a virtual email address and credit card you can use to sign up and pay.  All the charges will be tracked, managed and expensed automatically.
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle2">
                      Does this cost anything?
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" >
                      AppBind charges you 1% of the cost of the subscriptions you're managing plus whatever credit card fees incurred.
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle2" >
                      How do I get paid?
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" >
                      Once you connect your bank account (through ACH) or PayPal, we will transfer funds to you.
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle2">
                      When do I get paid?
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" >
                      You'll be paid out at your request if your balance exceeds the cost of transferring funds to you.
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle2" >
                      What is AppBind?
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" >
                      AppBind is a tool that lets you manage subscriptions from vendors on behalf of your customers
                  </Typography>
                </Grid>

                {/* TODO replace this vendor with vendor name when finalized */}
                <Grid item xs={12}>
                  <Typography variant="subtitle2">
                      What is the relationship between AppBind and this vendor?
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" >
                      The vendor is a partner of AppBind.  Your AppBind account belongs to you.  We only share information to the vendor you opt in to provide.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

          </Grid>
        </div>
      );
    }
  }
}

export default withStyles(styles)(PartnerHome);